import React from 'react';

interface PageBackgroundProps {
  children: React.ReactNode;
  variant?: 'default' | 'subtle' | 'aurora';
}

export const PageBackground: React.FC<PageBackgroundProps> = ({ 
  children, 
  variant = 'default' 
}) => {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Base gradient overlay */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Top gradient glow */}
        <div 
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[1200px] h-[600px] opacity-[0.03]"
          style={{
            background: 'radial-gradient(ellipse at center, hsl(190 100% 50%) 0%, transparent 70%)',
          }}
        />
        
        {/* Subtle grid pattern */}
        <div 
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundImage: `linear-gradient(hsl(0 0% 100% / 0.1) 1px, transparent 1px),
                             linear-gradient(90deg, hsl(0 0% 100% / 0.1) 1px, transparent 1px)`,
            backgroundSize: '64px 64px',
          }}
        />
        
        {/* Bottom fade */}
        <div 
          className="absolute bottom-0 left-0 right-0 h-[400px]"
          style={{
            background: 'linear-gradient(to top, hsl(0 0% 4%) 0%, transparent 100%)',
          }}
        />
      </div>
      
      {/* Aurora effect for special pages */}
      {variant === 'aurora' && (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div
            className="absolute top-1/4 left-1/4 w-[600px] h-[600px] rounded-full opacity-[0.04] blur-[100px] animate-pulse"
            style={{
              background: 'radial-gradient(circle, hsl(190 100% 50%) 0%, transparent 70%)',
              animationDuration: '8s',
            }}
          />
          <div
            className="absolute top-1/3 right-1/4 w-[400px] h-[400px] rounded-full opacity-[0.03] blur-[80px] animate-pulse"
            style={{
              background: 'radial-gradient(circle, hsl(280 100% 60%) 0%, transparent 70%)',
              animationDuration: '12s',
              animationDelay: '2s',
            }}
          />
        </div>
      )}
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};
